import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import { isLegacyBrowser } from 'lib/browser';
import { getBrowser } from 'store/userEnvironment/userEnvironmentSelectors';

const LegacyBrowserBoundary = ({ children }) => {
  const browser = useSelector(getBrowser);
  return isLegacyBrowser(browser.name) ? null : children;
};

LegacyBrowserBoundary.propTypes = {
  children: PropTypes.node,
};

LegacyBrowserBoundary.defaultProps = {
  children: null,
};

export default LegacyBrowserBoundary;
